import React from "react";
import "../Navigation/css/NavBar.scss";
import {Black} from "../../theme/styles";
import equipmentEnterpriseObject from "../../assets/equipmentEnterpriseObject.png";
import equipmentRevisionEnterpriseObject from "../../assets/equipmentRevisionEnterpriseObject.png";

export default function Lots() {

    return (
        <div style={{paddingLeft: "20px", paddingRight: "30px"}}>
            <p style={{fontSize: "24px", fontWeight: "400", color: Black}}>Equipment</p>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>REST APIs support the handling of equipment in Enlil.</p>
            <ul style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                <li style={{marginTop: "20px"}}>In Enlil, equipment are documents whose document type group attribute is set to "EQUIPMENT". This family of APIs allows for the retrieval, creation and updating of parts.</li>
            </ul>
            <br/>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>The Enterprise Object Model for Equipment is detailed below. Other Enlil entities (Equipment, Material, etc.) have a similar Enterprise Object Model.</p>
            <br/>
            <img src={equipmentEnterpriseObject} alt={"Model"}/>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>The Enterprise Object Model for Equipment Revisions is detailed below. Other Enlil entities (Equipment Revision, Supplier Revision, etc.) have a similar Enterprise Object Model.</p>
            <br/>
            <img src={equipmentRevisionEnterpriseObject} alt={"Model"}/>
        </div>
    )
}